var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":require(("@/assets/" + (_vm.content.path) + "/" + (_vm.content.image))),"alt":_vm.content.imageAlt,"width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }